var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.circle,style:(_vm.wrapperStyle)},[_c('img',{class:_vm.$style.image,attrs:{"src":_vm.src,"alt":"profile logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }